<template>
    <div v-if="!data.plan.isFree" class="add-show-step-4 pro-plan-payment">
        <div class="top-content">
            <h2>Confirm Your Payment Info</h2>
            <p>You’re almost done! Pick how often you’d like to pay.</p>
        </div>
        <div class="payment">
            <div class="payment-container">
                <show-purchase
                    v-if="! hasSubscription || subscribingUser"
                    :loading="convertingShow"
                    :billing-plan="data.plan"
                    @subscription-finished="handleShowUpdate"
                    @subscribing-user="subscribingUser = ! subscribingUser"
                >
                   <template v-slot:credit-card-header>
                        <p class="title">
                            Enter your credit card info
                        </p>
                   </template>
                </show-purchase>
                <template v-else>
                    <subscription-update
                        :show="data.show"
                        :loading="convertingShow"
                        :billing-plan="data.plan"
                        @subscription-finished="handleShowUpdate"
                    />
                </template>
            </div>
            <div class="pro-features">
                <p>Fusebox {{ data.plan.name }}</p>
                <plan-features :features="data.plan.features" />
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import getActiveSubscription from '@/utils/getActiveSubscription';
import ShowPurchase from './Payment/ShowPurchase';
import SubscriptionUpdate from './Payment/SubscriptionUpdate';
import toasts from '@/mixins/toasts';
import PlanFeatures from '@/components/Shows/PlanFeatures';

export default {
    components: {
        PlanFeatures,
        ShowPurchase,
        SubscriptionUpdate,
    },

    mixins: [toasts],

    props: {
        data: {
            type: [Object],
            default: () => ({}),
        },
    },

    data: () => ({
        editingCard: false,
        subscribingUser: false,
        convertingShow: false,
        addOnNames: {
            hosting: 'Easy Hosting',
        },
        intervalProducts: false,
    }),

    computed: {
        ...mapState(['user']),

        /**
         * Check if user has subscription
         *
         * @returns  {boolean}  True/false
         */
        hasSubscription() {
            return !! getActiveSubscription(this.user.subscriptions);
        },
    },

    /**
     * Component created hook.
     */
    created() {
        if (this.data.plan.isFree) {
            this.$emit('proceed', this.data);
        }
    },

    methods: {
        ...mapActions(['convertShow']),

        /**
         * Handles show update after subscription has been created.
         */
        async handleShowUpdate() {
            this.convertingShow = true;

            try {
                await this.convertShow({
                    showHash: this.data.show.hash,
                    subscriptionId: this.user.subscriptions[0].id,
                    planId: this.data.plan.id,
                });

                this.$emit('proceed', this.data);
            } catch (e) {
                this.toastError({
                    message: {
                        title: 'We could not add subscription to your show. Please try again later or contact us.',
                    },
                });
            }

            this.convertingShow = false;
        },
    },
};
</script>
